export default function initAdvancedFiltersToggle() {
    const toggleBtn = document.getElementById('toggleAdvancedFilters');
    const filters = document.getElementById('advancedFilters');
    const icon = toggleBtn?.querySelector('i');

    if (!toggleBtn || !filters || !icon) return;

    let isOpen = false;

    // Apri i filtri se ci sono query string diverse da "s" o "cpt"
    const urlParams = new URLSearchParams(window.location.search);

    const ignore = ['s', 'cpt', 'paged', 'orderby', 'order'];
    // Trova solo i parametri valorizzati e rilevanti
    const activeFilters = [...urlParams.entries()].filter(([key, value]) => {
        if (ignore.includes(key)) return false;
        if (!value || value.trim() === '') return false;
        return true;
    });

    if (activeFilters.length > 0) {
        // Considera filtri avanzati attivi
        isOpen = true;
        filters.style.display = 'block';
        filters.style.height = 'auto';

        icon.classList.remove('fa-circle-plus');
        icon.classList.add('fa-circle-minus');
    }

    toggleBtn.addEventListener('click', () => {
        isOpen = !isOpen;

        if (isOpen) {
            // === SLIDE DOWN ===
            filters.style.display = 'block';
            filters.style.height = '0px';
            filters.offsetHeight;
            filters.style.transition = 'height 0.3s ease';
            filters.style.height = filters.scrollHeight + 'px';

            filters.addEventListener('transitionend', function handleEnd() {
                filters.style.height = 'auto';
                filters.removeEventListener('transitionend', handleEnd);
            });

            icon.classList.remove('fa-circle-plus');
            icon.classList.add('fa-circle-minus');

        } else {
            // === SLIDE UP (nascondi subito contenuti interni) ===
            // Aggiungi classe temporanea che rende invisibili i contenuti
            filters.classList.add('closing');

            // Imposta l'altezza fissa prima dello slide
            filters.style.height = filters.scrollHeight + 'px';
            filters.offsetHeight;
            filters.style.transition = 'height 0.3s ease';
            filters.style.height = '0px';

            filters.addEventListener('transitionend', function handleEnd() {
                filters.style.display = 'none';
                filters.classList.remove('closing');
                filters.removeEventListener('transitionend', handleEnd);
            });

            icon.classList.remove('fa-circle-minus');
            icon.classList.add('fa-circle-plus');
        }
    });

    // ✅ NEW: reset secondary filters when CPT changes
    const form = document.querySelector('form#FormMainSearch'); // meglio: selettore del tuo form di ricerca, vedi nota sotto
    const cptRadios = document.querySelectorAll('input[type="radio"][name="cpt"]');

    if (form && cptRadios.length) {
        cptRadios.forEach(radio => {
            radio.addEventListener('change', () => {
                fsrResetSecondaryFilters(form);
                form.submit();
            });
        });
    }
}

function fsrResetSecondaryFilters(form) {
    // 1) reset checkbox filters
    form.querySelectorAll('input[type="checkbox"]').forEach(el => { el.checked = false; });

    // 2) remove hidden inputs except technical ones
    form.querySelectorAll('input[type="hidden"]').forEach(el => {
        if (el.name !== 's' && el.name !== 'cpt') el.remove();
    });

    // 3) reset dropdown internal search inputs (not main keyword)
    form.querySelectorAll('input[type="text"]').forEach(el => {
        if (el.name === 's') return;
        if (el.id && el.id.startsWith('inputInside-')) el.value = '';
    });
}

export function initCptHorizontalScroll() {
    const container = document.querySelector('.Search__filters--options');
    if (!container) return;

    const isMobile = window.matchMedia('(max-width: 1080px)').matches;
    if (!isMobile) return;

    const scrollToLabel = (inputEl, behavior = 'smooth') => {
        if (!inputEl || !inputEl.id) return;
        const label = container.querySelector(`label[for="${CSS.escape(inputEl.id)}"]`);
        if (!label) return;

        // centra il label nel container orizzontale
        const left =
            label.offsetLeft - (container.clientWidth / 2) + (label.clientWidth / 2);

        container.scrollTo({
            left: Math.max(0, left),
            behavior,
        });
    };

    // 1) on load: scroll al checked
    const checked = container.querySelector('input[type="radio"][name="cpt"]:checked');
    if (checked) {
        // "auto" per evitare animazione al load (più pulito)
        scrollToLabel(checked, 'auto');
    }

    // 2) on click/change: scroll subito (poi submit)
    container.addEventListener('change', (e) => {
        const target = e.target;
        if (!(target instanceof HTMLInputElement)) return;
        if (target.type !== 'radio' || target.name !== 'cpt') return;

        scrollToLabel(target, 'smooth');
    });

    // opzionale: se la selezione avviene cliccando sul label (non sempre triggera subito change)
    container.addEventListener('click', (e) => {
        const lbl = e.target.closest('label');
        if (!lbl) return;
        const forId = lbl.getAttribute('for');
        if (!forId) return;
        const input = container.querySelector(`#${CSS.escape(forId)}`);
        if (input) scrollToLabel(input, 'smooth');
    });
}
